import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0283a0',
      light: '#349bb3',
      dark: '#015b70',
    },
    secondary: {
      main: '#36454F',
      light: '#5F6A6E',
      dark: '#2B303B',
    },
    // secondary: {
    //   main: '#831A1A',
    //   light: '#9b4747',
    //   dark: '#5b1212',
    // },
    error: {
      main: '#831A1A',
      light: '#9b4747',
      dark: '#5b1212',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      '"Open Sans"',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
});

export default theme;
